import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorService, ErrorMessage } from '../../../services/error.service';

@Component({
  selector: 'app-error-notification',
  templateUrl: './error-notification.component.html',
  styleUrls: ['./error-notification.component.scss']
})
export class ErrorNotificationComponent implements OnInit, OnDestroy {
  error: ErrorMessage | null = null;
  private errorSubscription: Subscription | null = null;

  constructor(private errorService: ErrorService) {}

  ngOnInit() {
    this.errorSubscription = this.errorService.error$.subscribe(error => {
      this.error = error;
      if (error) {
        // Automatisches Ausblenden nach 5 Sekunden
        setTimeout(() => {
          this.clearError();
        }, 5000);
      }
    });
  }

  ngOnDestroy() {
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
    }
  }

  clearError() {
    this.errorService.clearError();
  }

  getIcon(): string {
    if (!this.error) return '';
    
    switch (this.error.type) {
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'info';
    }
  }

  getColor(): string {
    if (!this.error) return '';
    
    switch (this.error.type) {
      case 'error':
        return 'red';
      case 'warning':
        return 'orange';
      case 'info':
        return 'blue';
      default:
        return 'blue';
    }
  }
} 